const initialInvestState = {
    userInvestDataLoaded: false,
    userInvestmentID: -1,
    userKYCVerified: false,
    userBankingDetails: false,
    userInvestMode: false,
    cacheUserData: {},
    userCacheDataLoaded: false,
    cacheBankingData: "",
    transactionCacheDataLoaded: false,
    transactionData: [],
    currentInvestDetail: 0,
    hasPendingTransaction: false,
    pendingAmount: 0,
    historicalLoadedDays: 0,
    loadingMoreHistoricalData: false,
    idToLabelEnum : [
        {label: "Australian Shares", id: 7, sortingOrder: 1},
        {label: "Cash", id: 1, sortingOrder: 2},
        {label: "FANG Plus Shares", id: 2, sortingOrder: 3},
        {label: "Gold", id: 3, sortingOrder: 4},
        {label: "International Sustainability", id: 4, sortingOrder: 5},
        {label: "NASDAQ Shares", id: 5, sortingOrder: 6},
        {label: "US Shares", id: 6, sortingOrder: 7}
    ],
    recurringInstructions: [],
    recurringInstructionsLoaded: false,
    statementList: [],
    statementListLoaded: false
}

const investReducer = (state = initialInvestState, action) => {
    switch (action.type) {
        case 'LOAD_USER_INVEST_ID':
            return Object.assign({}, state, {
                userInvestmentID: action.userInvestmentID,
                userInvestDataLoaded: true
            })
        case 'LOAD_USER_BANKING_DETAILS':
            return Object.assign({}, state, {
                userBankingDetails: true,
                cacheBankingData: action.cacheBankingData
            })
        case 'LOAD_USER_CACHE_DETAILS':
            return Object.assign({}, state, {
                userCacheDataLoaded: true,
                cacheUserData: action.cacheUserData
            })
        case 'LOAD_USER_INVEST_MODE':
            return Object.assign({}, state, {
                userInvestMode: true
            })
        case 'SET_USER_KYC_VERI':
            return Object.assign({}, state, {
                userKYCVerified: true
            })
        case 'LOAD_USER_BULK_DETAILS':
                return Object.assign({}, state, {
                    userKYCVerified: action.KYCVeri,
                    userBankingDetails: action.Banking,
                    userInvestMode: action.InvestMode
                })
        case 'SET_LOADED_TRANSACTION_DATA':
            return Object.assign({}, state, {
                transactionData: action.transactionData,
                historicalLoadedDays: action.timeScale,
                transactionCacheDataLoaded: true,
                loadingMoreHistoricalData: false
            }) 
        case 'SET_INVEST_DETAIL_ID':
            return Object.assign({}, state, {
                currentInvestDetail: action.investTypeId
            })
        case 'SET_HAS_PENDING_TRANSACTION':
            return Object.assign({}, state, {
                hasPendingTransaction: action.pendingTransaction,
                pendingAmount: action.pendingAmount
            })
        case 'SET_LOADING_HISTORICAL_DATA_FLAG':
            return Object.assign({}, state, {
                loadingMoreHistoricalData: true,
            })
        case 'LOAD_RECURRING_TRANSACTIONS':
            return Object.assign({}, state, {
                recurringInstructionsLoaded: true,
                recurringInstructions: action.recurringInstructions
            })
        case 'LOAD_STATEMENT_LIST':
            return Object.assign({}, state, {
                statementListLoaded: true,
                statementList: action.statementList
            }) 
        default:
            return state
    }
}

export default investReducer;